module.exports = "pegasus/assets/tech/birthday/101.png";